module.exports = __webpack_public_path__ + "static/media/main_visual_construction_telehandler_mt_730_h_manitou.ffed49f4.png";